"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6884],{

/***/ 46884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var Item = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(__webpack_require__.e(/* import() */ 9743).then(__webpack_require__.bind(__webpack_require__, 79743)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79743)
            ];
        }
    }
});
var PopularCities = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "border-b border-white",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "text-white",
                    children: "Popular Cities"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-white pt-2 flex flex-col gap-1",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Item, {
                        search: "/city/Mississauga",
                        title: "Bungalows for sale Mississauga Ontario"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Item, {
                        search: "/city/Toronto",
                        title: "Bungalows for sale Toronto Ontario"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Item, {
                        search: "/city/Brampton",
                        title: "Bungalows for sale Brampton Ontario"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Item, {
                        search: "/city/Ajax",
                        title: "Bungalows for sale Ajax Ontario"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Item, {
                        search: "/city/Burlington",
                        title: "Bungalows for sale Burlington Ontario"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Item, {
                        search: "/city/Milton",
                        title: "Bungalows for sale Milton Ontario"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Item, {
                        search: "/city/Hamilton",
                        title: "Bungalows for sale Hamilton Ontario"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Item, {
                        search: "/city/Oakville",
                        title: "Bungalows for sale Oakville Ontario"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Item, {
                        search: "/city/Caledon",
                        title: "Bungalows for sale Caledon Ontario"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (PopularCities);


/***/ })

}]);